import * as React from 'react';
import Button from '../../../common/components/Button';
import {CALCULATOR} from '../../constants/LabelConstants';
import AssetsManager from '../../../common/utils/AssetsManager';
import {NotFoundProps} from '../../types/mx/creditoReal/components';

export default class NotFoundView extends React.Component<NotFoundProps, {}> {

    getRandomImage = () => Math.floor(Math.random() * 3) + 1;

    render() {
        return (
            <div className="container my-5">
                <div className="row">
                    <div className="col my-5 text-center">
                        <img className="img-fluid pb-5 px-3" alt="404"
                             src={AssetsManager(`/assets/images/common/error-404-${this.getRandomImage()}.svg`)}/>
                        <h1 className="text-raleway display-4 font-weight-bold">Oppsss…</h1>
                        <h4 className="text-raleway">La página que estás intentando acceder no existe</h4>
                        <Button text={CALCULATOR.START_LOAN}
                                onPress={this.props.onPressInit} customClass=" px-md-5"/>
                    </div>
                </div>
            </div>
        );
    }
}